// import { take, call, put, select } from 'redux-saga/effects';
import { call, put, all, spawn, takeLatest } from 'redux-saga/effects';
import {
  INSTANT,
  VENDOR,
  GET_SETTLEMENT_HOLIDAYS_URL,
  GET_UNSETTLED_AMOUNT_URL,
  GET_IMPORT_UNSETTLED_AMOUNT_URL,
  GET_UNIFICATION_ONBOARDING_URL,
  VENDOR_DETAILS,
} from 'utils/constants';
import request from 'utils/request';

import {
  GENERATE_SETTLEMENTS_REPORTS_URL,
  SEARCH_SETTLEMENTS_VENDOR_URL,
  GENERATE_REPORT_URL,
  GET_IMPORTS_SETTLEMENT_DETAILS_URL,
} from 'constants/url';

import { showToast } from '../Toast/actions';
import {
  saveSettlementsAction,
  saveImportSettlementsAction,
  disableLoaderAction,
  saveSettlementsHolidaysAction,
  updateUnsettledAmount,
  saveNextSettlementsDetailsAction,
} from './actions';
import {
  SEARCH_SETTLEMENTS,
  SEARCH_SETTLEMENTS_IMPORT,
  SEARCH_SETTLEMENTS_STANDARD_URL,
  SEARCH_SETTLEMENTS_INSTANT_URL,
  GENERATE_SETTLEMENT_REPORT,
  GET_SETTLEMENT_HOLIDAYS,
  GET_ON_DEMAND_SETTLEMENT_STATUS,
  GET_ON_DEMAND_SETTLEMENT_STATUS_URL,
  GET_UNSETTLED_AMOUNT,
  GET_SETTLEMENT_RATES,
  GET_SETTLEMENT_RATES_URL,
  GET_UNIFICATION_ONBOARDING,
  GET_INSTANT_SETTLEMENTS_ELIGIBILITY,
  GET_INSTANT_SETTLEMENTS_ELIGIBILITY_URL,
  REQUEST_INSTANT_SETTLEMENTS_ONBOARDING,
  REQUEST_INSTANT_SETTLEMENTS_ONBOARDING_URL,
  GET_INSTANT_SETTLEMENTS_MAX_DAILY_LIMIT,
  GET_INSTANT_SETTLEMENTS_MAX_DAILY_LIMIT_URL,
  GET_INSTANT_SETTLEMENTS_RATES_AND_LIMITS,
  GET_INSTANT_SETTLEMENTS_RATES_AND_LIMITS_URL,
  GET_SETTLEMENT_TIMELINE,
  SEARCH_SETTLEMENTS_TIMELINE_URL,
  SEARCH_VENDOR_SETTLEMENTS_TIMELINE_URL,
  GET_NEXT_SETTLEMENTS_DETAILS,
  GET_NEXT_SETTLEMENTS_DETAILS_URL,
  GET_OFFLINE_NEXT_SETTLEMENTS_DETAILS_URL,
} from './constants';

function getURLBasedOnActiveNavigation(activeNavigation = '') {
  const VENDOR_TYPE = VENDOR_DETAILS.find(v => v === activeNavigation);
  switch (activeNavigation) {
    case INSTANT:
      return SEARCH_SETTLEMENTS_INSTANT_URL;
    case VENDOR_TYPE:
      return SEARCH_SETTLEMENTS_VENDOR_URL;
    default:
      return SEARCH_SETTLEMENTS_STANDARD_URL;
  }
}

function getLiveURLBasedOnActiveNavigation(activeNavigation = '') {
  const VENDOR_TYPE = VENDOR_DETAILS.find(v => v === activeNavigation);
  switch (activeNavigation) {
    case VENDOR_TYPE:
      return SEARCH_VENDOR_SETTLEMENTS_TIMELINE_URL;
    default:
      return SEARCH_SETTLEMENTS_TIMELINE_URL;
  }
}

function getDownloadURLOnActiveNavigation(activeNavigation = '') {
  const TYPE = VENDOR_DETAILS.find(v => v === activeNavigation);
  switch (activeNavigation) {
    case TYPE: {
      return GENERATE_REPORT_URL;
    }
    default: {
      return GENERATE_SETTLEMENTS_REPORTS_URL;
    }
  }
}
export function* searchSettlements({ data }) {
  try {
    const { activeNavigation, options: reqOptions, cb, settlementType } = data;
    const { url, method } = getURLBasedOnActiveNavigation(activeNavigation);

    let updatedReqOptions = { ...reqOptions };
    if (settlementType === 'offline') {
      updatedReqOptions = { ...updatedReqOptions, tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions || {},
    };
    const response = yield call(request, url, options);
    let currentNavigation = activeNavigation;
    if (VENDOR_DETAILS.includes(activeNavigation)) {
      currentNavigation = VENDOR;
    }
    yield put(
      saveSettlementsAction({
        data: response,
        activeNavigation: currentNavigation,
      }),
    );
    if (cb) {
      cb({
        data: response,
        activeNavigation,
      });
    }
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* searchImportSettlements({ data }) {
  try {
    const { activeNavigation, options: reqOptions } = data;
    const { url, method } = GET_IMPORTS_SETTLEMENT_DETAILS_URL;

    const updatedReqOptions = { ...reqOptions };

    const options = {
      method,
      queryString: updatedReqOptions || {},
    };

    const response = yield call(request, url, options);

    yield put(
      saveImportSettlementsAction({
        data: response,
        activeNavigation,
      }),
    );
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* generateSettlementReport({ data }) {
  const {
    cb,
    activeNavigation,
    actions,
    settlementType,
    ...reqOptions
  } = data.options;
  try {
    const { url, method } = getDownloadURLOnActiveNavigation(activeNavigation);

    let updatedReqOptions = {};

    if (activeNavigation.toUpperCase().trim() !== VENDOR) {
      updatedReqOptions = { ...reqOptions };
    }

    if (settlementType === 'offline') {
      updatedReqOptions = { ...updatedReqOptions, tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    yield put(disableLoaderAction());
    if (cb) cb(response);
  } catch (err) {
    if (actions) actions.setSubmitting(false);
    yield put(disableLoaderAction());
    yield put(showToast(err));
    if (cb) {
      cb({ error: err });
    }
  }
}

export function* getSettlementHolidays({ data: { settlementType } }) {
  try {
    const { url, method } = GET_SETTLEMENT_HOLIDAYS_URL;
    let queryString = {};

    if (settlementType === 'offline') {
      queryString = { tenant: 'op' };
    }
    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString,
    };
    const response = yield call(request, url, options);
    yield put(saveSettlementsHolidaysAction(response));
    // eslint-disable-next-line no-empty
  } catch (err) {}
}

export function* getOnDemandSettlementStatus({
  data: { isModuleFederated, cb, settlementType },
}) {
  try {
    const { url, method } = GET_ON_DEMAND_SETTLEMENT_STATUS_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      isModuleFederated,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Settlements-onDemandStatus', err);
    // yield put(showToast(err));
  }
}

export function* getSettlementRates({ data: { cb, settlementType } }) {
  try {
    const { url, method } = GET_SETTLEMENT_RATES_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* getUnsettledAmount({
  data: { cb, settlementType, isMerchantImportEnabled },
}) {
  try {
    const { url, method } = isMerchantImportEnabled
      ? GET_IMPORT_UNSETTLED_AMOUNT_URL
      : GET_UNSETTLED_AMOUNT_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }
    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    yield put(updateUnsettledAmount(response));
  } catch (err) {
    yield put(showToast(err));
  } finally {
    if (cb) cb();
  }
}

export function* getUnificationOnboarding({ data: { cb, settlementType } }) {
  try {
    const { url, method } = GET_UNIFICATION_ONBOARDING_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* getInstantSettlementsEligibility({
  data: { cb, settlementType },
}) {
  try {
    const { url, method } = GET_INSTANT_SETTLEMENTS_ELIGIBILITY_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    // yield put(showToast(err));
  }
}

export function* getInstantSettlementsRatesAndLimits({
  data: { cb, settlementType },
}) {
  try {
    const { url, method } = GET_INSTANT_SETTLEMENTS_RATES_AND_LIMITS_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* getInstantSettlementsMaxDailyLimit({
  data: { cb, errorCb, settlementType },
}) {
  try {
    const { url, method } = GET_INSTANT_SETTLEMENTS_MAX_DAILY_LIMIT_URL;

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString: updatedReqOptions,
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(showToast(err));
    errorCb();
  }
}

export function* requestInstantSettlementsOnboarding({
  data: { payload, successCb, errorCb, settlementType },
}) {
  try {
    const { url, method } = REQUEST_INSTANT_SETTLEMENTS_ONBOARDING_URL;

    let updatedPaylod = { ...payload };
    if (settlementType === 'offline') {
      updatedPaylod = { ...updatedPaylod, tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      body: JSON.stringify(updatedPaylod),
    };
    const response = yield call(request, url, options);
    if (successCb) successCb(response);
  } catch (err) {
    if (errorCb) errorCb();
    yield put(showToast(err));
  }
}

export function* getSettlementTimeline({
  data: { inProgressSettlements, cb, activeNavigation, settlementType },
}) {
  try {
    const { url, method } = getLiveURLBasedOnActiveNavigation(activeNavigation);

    let updatedReqOptions = {};
    if (settlementType === 'offline') {
      updatedReqOptions = { tenant: 'op' };
    }

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      queryString:
        // eslint-disable-next-line prettier/prettier
        inProgressSettlements && inProgressSettlements.length ? {settlementIds: inProgressSettlements.join(','), ...updatedReqOptions} : { ...updatedReqOptions },
    };
    const response = yield call(request, url, options);
    if (!response) {
      cb({ error: 'Data not found' });
      return;
    }
    if (cb) {
      cb(response);
    }
  } catch (error) {
    yield put(showToast(error));
    if (cb) {
      cb({ error });
    }
  }
}

export function* getNextSettlementsDetails({ data: { settlementType } }) {
  try {
    const { url, method } =
      settlementType === 'offline'
        ? GET_OFFLINE_NEXT_SETTLEMENTS_DETAILS_URL
        : GET_NEXT_SETTLEMENTS_DETAILS_URL;

    const response = yield call(request, url, { method });

    yield put(saveNextSettlementsDetailsAction(response));
  } catch (error) {
    yield put(saveNextSettlementsDetailsAction({}));
    yield put(showToast(error));
  }
}

export function* getNextSettlementsDetailsSaga() {
  yield takeLatest(GET_NEXT_SETTLEMENTS_DETAILS, getNextSettlementsDetails);
}

export function* searchSettlementsSaga() {
  yield takeLatest(SEARCH_SETTLEMENTS, searchSettlements);
}

export function* searchImportSettlementsSaga() {
  yield takeLatest(SEARCH_SETTLEMENTS_IMPORT, searchImportSettlements);
}

export function* generateSettlementReportSaga() {
  yield takeLatest(GENERATE_SETTLEMENT_REPORT, generateSettlementReport);
}

export function* getSettlementHolidaysSaga() {
  yield takeLatest(GET_SETTLEMENT_HOLIDAYS, getSettlementHolidays);
}

export function* getUnsettledAmountSaga() {
  yield takeLatest(GET_UNSETTLED_AMOUNT, getUnsettledAmount);
}

export function* getSettlementRatesSaga() {
  yield takeLatest(GET_SETTLEMENT_RATES, getSettlementRates);
}

export function* getUnificationOnboardingSaga() {
  yield takeLatest(GET_UNIFICATION_ONBOARDING, getUnificationOnboarding);
}

export function* getInstantSettlementsEligibilitySaga() {
  yield takeLatest(
    GET_INSTANT_SETTLEMENTS_ELIGIBILITY,
    getInstantSettlementsEligibility,
  );
}

export function* requestInstantSettlementsOnboardingSaga() {
  yield takeLatest(
    REQUEST_INSTANT_SETTLEMENTS_ONBOARDING,
    requestInstantSettlementsOnboarding,
  );
}

export function* getInstantSettlementsRatesAndLimitsSaga() {
  yield takeLatest(
    GET_INSTANT_SETTLEMENTS_RATES_AND_LIMITS,
    getInstantSettlementsRatesAndLimits,
  );
}

export function* getInstantSettlementsMaxDailyLimitSaga() {
  yield takeLatest(
    GET_INSTANT_SETTLEMENTS_MAX_DAILY_LIMIT,
    getInstantSettlementsMaxDailyLimit,
  );
}

export function* getOnDemandSettlementStatusSaga() {
  yield takeLatest(
    GET_ON_DEMAND_SETTLEMENT_STATUS,
    getOnDemandSettlementStatus,
  );
}

export function* getSettlementTimelineSaga() {
  yield takeLatest(GET_SETTLEMENT_TIMELINE, getSettlementTimeline);
}

// Individual exports for testing
export default function* settlementsSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    searchSettlementsSaga,
    searchImportSettlementsSaga,
    generateSettlementReportSaga,
    getSettlementHolidaysSaga,
    getUnsettledAmountSaga,
    getSettlementRatesSaga,
    getUnificationOnboardingSaga,
    getOnDemandSettlementStatusSaga,
    getInstantSettlementsEligibilitySaga,
    requestInstantSettlementsOnboardingSaga,
    getInstantSettlementsMaxDailyLimitSaga,
    getInstantSettlementsRatesAndLimitsSaga,
    getSettlementTimelineSaga,
    getNextSettlementsDetailsSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
